import React from "react";
import clsx from "clsx";

import { ReportDetailItem } from "../../../../services/mangerReportServices";
import ImagePreview from "../../../Input/ImagePreview";

type Props = {
  reportDetail: ReportDetailItem;
};

export default function ManagerReportBeforeAfterImage({ reportDetail }: Props) {
  const preList =
    (reportDetail.s3PreFile || reportDetail.s3PostFile
      ? reportDetail.s3PreFile
      : reportDetail.zadaraPrePathList) ?? [];
  const postList =
    (reportDetail.s3PreFile || reportDetail.s3PostFile
      ? reportDetail.s3PostFile
      : reportDetail.zadaraPostPathList) ?? [];
  const gridCount =
    (preList.length > 0 ? 1 : 0) + (postList.length > 0 ? 1 : 0);

  if (preList.length === 0 && postList.length === 0) {
    return null;
  }

  return (
    <div
      className={clsx([
        "grid gap-2.5 w-full",
        {
          "grid-cols-2": gridCount === 2,
          "grid-cols-1": gridCount === 1,
        },
      ])}
    >
      {preList.length > 0 && (
        <div className="flex justify-center w-full">
          <ImagePreview
            key={0}
            image={preList?.[0]?.filePath}
            imageList={preList.map((item) => item.filePath)}
            index={0}
            className="!w-full h-[calc((100vw-90px)/2)]"
            wrapperClassName="w-full"
            label="처리 전"
            remainCount={preList.length > 2 ? preList.length - 1 : undefined}
          />
        </div>
      )}

      {postList.length > 0 && (
        <div className="flex justify-center w-full">
          <ImagePreview
            key={0}
            image={postList?.[0]?.filePath}
            imageList={postList.map((item) => item.filePath)}
            index={0}
            className="!w-full h-[calc((100vw-90px)/2)]"
            wrapperClassName="w-full"
            label="처리 후"
            remainCount={postList.length > 2 ? postList.length - 1 : undefined}
          />
        </div>
      )}
    </div>
  );
}
